import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import { computed } from "vue";
import {
  appStore,
  orgApiStore,
  orgStore,
  permissionStore,
  saveOrgStore,
} from "@/hooks";
import { FlexBox, TextButton } from "@/components/common";


/**
 * Displays an organization's actions.
 */
const __default__ = {
  name: "OrganizationButtons",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const displayEdit = computed(() =>
  permissionStore.isAllowed("org.edit", orgStore.org)
);
const displayDelete = computed(() =>
  permissionStore.isAllowed("org.delete", orgStore.org)
);

/**
 * Opens the organization editor.
 */
function handleEdit() {
  saveOrgStore.resetOrg(orgStore.org);
  appStore.open("saveOrg");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(FlexBox), {
    t: "2",
    class: "settings-buttons"
  }, {
    default: _withCtx(() => [
      (displayEdit.value)
        ? (_openBlock(), _createBlock(_unref(TextButton), {
            key: 0,
            text: "",
            label: "Edit",
            icon: "edit",
            "data-cy": "button-org-edit",
            onClick: handleEdit
          }))
        : _createCommentVNode("", true),
      (displayDelete.value)
        ? (_openBlock(), _createBlock(_unref(TextButton), {
            key: 1,
            text: "",
            label: "Delete",
            icon: "delete",
            "data-cy": "button-org-delete",
            loading: _unref(orgApiStore).deleteOrgApiLoading,
            onClick: _unref(orgApiStore).handleDelete
          }, null, 8, ["loading", "onClick"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})